import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import globals from 'scoreboard/components/globals'
import Wizard from 'scoreboard/components/wizard'
import projects from 'scoreboard/projects/projects'
import ProjectSelector from 'scoreboard/projects/project-selector'
import PasteForm from 'scoreboard/components/paste/copy-move-destination-form'

const AttachForm = PasteForm.extend({
	initialize(options = {}) {
		PasteForm.prototype.initialize.apply(this, arguments)
		options.primaryButtonLabel = i18n.get('common.save')
	},

	test() {
		//ensure there is an org id to send (globals.orgId may be nil if user hasn't selected one yet)
		if (_.get(this.getOrg(),'id', null) == null && _.isNil(globals.orgId)) {
			return ['error']
		}
		return false
	},

	title() {
		return i18n.get('bookmarks.edit.saveTo', `<q>${_.escape(this.options.object.label)}</q>`)
	},

	_onPaste(options, ids) {
		//don't want to trigger a 'move:domain-object' event due to all the side effects
		Backbone.trigger('attach:domain-object', options, ids)
	}
})

const MoveToOrgWizard = Wizard.extend({

	/**
	 * View to attach an org-less item to an org.
	 *
	 * @param {String} options.mode		either 'move' or 'copy' to determine which validation rules to follow
	 * @param {String} options.section	the type of object to be selected
	 * @param {Object} options.object	the object being moved or copied, which must have ID and label properties
	 * @param {String} options.domainType	the domain type of the object being moved or copied
	 * @param {String} [options.primaryButtonLabel='common.save']	I18N code for the text of the "Save" button
	 * @param {String} [options.titleCode='common.project.selectProject']	I18N code to display on title. Only shown if projects are enabled
	 */
	initialize(options = {}) {
		this.options = options || {}
		let views = [ ProjectSelector, AttachForm ]
		if (projects.single()) {
			views = [ AttachForm ]
			this.options.projectId = projects.id
		}
		Wizard.prototype.initialize.call(this, _.extend({ views: views }, this.options))
	},

	saveState(data) {
		this.options.projectId = data
	}

})

export default MoveToOrgWizard
MoveToOrgWizard.__filename__ = 'bookmarks/move-to-org-wizard.js'
